import React from 'react';
import { Box } from '@mui/material';

const PageTransition = ({ children, transitionKey }) => {
  return (
    <Box
      key={transitionKey}
      sx={{
        width: '100%',
        animation: 'pageTransition 0.4s ease-out',
        '@keyframes pageTransition': {
          '0%': {
            opacity: 0,
            transform: 'translateY(20px)'
          },
          '100%': {
            opacity: 1,
            transform: 'translateY(0)'
          }
        }
      }}
    >
      {children}
    </Box>
  );
};

export default React.memo(PageTransition); 